<div class="form-container" id="main-page-div"
  [ngClass]="{'form-container-bills-to-pay': billsToPayMode && isSpinnerShown  }">
  <!-- SD-1235: the loader sits in the form's own column, centred in it. It was absolutely
       placed at screen-width percentages (left: 83–88%), which a leaked global
       `.sidebar-spinner { left: 50% }` (activity panel) then threw into the middle of the
       document beside it. -->
  <div class="form-loading" *ngIf="isSpinnerShown" role="status" aria-live="polite">
    <mat-spinner diameter="40" strokeWidth="3"></mat-spinner>
    <div class="form-loading__text">Data loading…</div>
  </div>
  <div class="back-area" *ngIf="returnBackToText" (click)="closeFormOnBillsToPay()">
    <div class="shevron">
      <img src="../../../../../assets/img/invoiceForm/shevron-white.svg" alt="">
    </div>
    <div class="text">Back to {{returnBackToText}}</div>
  </div>

  <div *ngIf="!isSpinnerShown">
    <!-- Controls -->
    <!-- Only where the header below is not drawn: everywhere else the close is one of the
         header's own actions, rather than an image pinned to the window's right edge. -->
    <div class="close-icon mobile-close" matTooltip="Hide Side Bar" [matTooltipShowDelay]="showToolTipDelay"
      [ngStyle]="{'padding-top': isoutlookEnv ? '49px' : isChromeEnv ? '30px' : '20px'}"
      (click)="closeFormOnBillsToPay()"
      *ngIf="isInboxMobileMode && !isPreviewVisible && (currentPannel == panels.ContactForm || currentPannel == panels.InvoiceDetails)">
      <img src="../../../../../assets/img/close-icon.svg" alt="">
    </div>
    <div class="controls" *ngIf="currentPannel != panels.ContactForm && currentPannel != panels.InvoiceDetails"
      [ngStyle]="{'padding-top': isoutlookEnv || isChromeEnv ? '30px' : '0'}">

      <section class="bill-header" [ngClass]="billsToPayMode ? 'bills-to-pay-mode' : ''">
        <div class="logo-container">
          <app-supplier-avatar class="logo {{hexColorClass}}"
            [supplierId]="currentSupplier.id || invoice.supplierId"
            [supplierName]="currentSupplier.name ? currentSupplier.name : invoice.supplierName">
            <span>{{(currentSupplier.name ? currentSupplier.name : invoice.supplierName) | shortLogo}}</span>
          </app-supplier-avatar>
        </div>
        <div class="desc">
          <!-- The supplier's name opens the supplier panel over this one. -->
          <div class="supplier" [ngClass]="billsToPayMode ? 'supplier-wider' : ''">
            <span [appOpenSupplier]="currentSupplier.id || invoice.supplierId">{{currentSupplier.name ? currentSupplier.name : invoice.supplierName ? invoice.supplierName : 'Supplier' }}</span>
          </div>
          <div class="bill-ref">
            <span>{{invoice.invoiceNumber}}</span>
            <app-status-pill *ngIf="invoice.processed && (invoice.status && invoice.status !== '')"
              [status]="getInvoiceStatus()" [integrationType]="getIntegrationType()" [showIcon]="true">
            </app-status-pill>
            <div class="pill-container">
              <span *ngIf="pendingTaskCount > 0" class="task-pill" (click)="showTaskDetails($event)">
                <i class="fas fa-bell"></i>
                {{pendingTaskCount}} Task{{pendingTaskCount > 1 ? 's' : ''}}
              </span>
              <span *ngIf="currentTaskCompleted" class="approval-tick">
                <i class="fas fa-check"></i>
              </span>
            </div>
            <span *ngIf="showApprovedTag" class="approved-invoice-tag">
              <i class="fas fa-check"></i> Approved
            </span>
            <div class="approval-animation" *ngIf="showApprovalAnimation">
              <i class="fas fa-check-circle"></i>
            </div>
          </div>
          <div
            *ngIf="((billsToPayMode && invoice.pdfUrl) || (isInboxMobileMode  && invoice.pdfUrl)) && !isPreviewVisibleWeb"
            class="view-invoice" (click)="viewInvoice()">View Invoice</div>
          <div *ngIf="(isPreviewVisibleWeb)" class="view-invoice"
            (click)="closeInvoicePreviewWebForm(invoice.invoiceId)">Hide Invoice</div>
        </div>
        <div class="bill-actions">
        <div class="arrows" *ngIf="!billsToPayMode && (!isPrevioustDisabled || !isNextDisabled) && !isInboxMobileMode">
          <div class="control">
            <button class="icon icon-left" [disabled]="isPrevioustDisabled"
              [ngClass]="isPrevioustDisabled ? 'disabled' : 'enabled'" matTooltip="Previous invoice"
              [matTooltipShowDelay]="showToolTipDelay" (click)="clickPreviousArrow()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
            </button>
          </div>
          <div class="control">
            <button class="icon icon-right" [disabled]="isNextDisabled"
              [ngClass]="isNextDisabled ? 'disabled' : 'enabled'" matTooltip="Next invoice"
              [matTooltipShowDelay]="showToolTipDelay" (click)="clickNextArrow()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
            </button>
          </div>
        </div>

        <button type="button" class="open-new-tab-icon" *ngIf="!billsToPayMode && isInboxMobileMode && !overlayMode"
          matTooltip="Open in inbox" [matTooltipShowDelay]="showToolTipDelay" aria-label="Open in inbox"
          (click)="openInInbox()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 4h6v6"/><path d="M20 4l-9 9"/><path d="M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4"/></svg>
        </button>
        <div class="dots-menu" *ngIf="!billsToPayMode">
          <button type="button" [matMenuTriggerFor]="menu" class="three-dots" matTooltip="More actions"
            [matTooltipShowDelay]="showToolTipDelay" aria-label="More actions">
            <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5.5" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="12" cy="18.5" r="1.6"/></svg>
          </button>
          <mat-menu #menu="matMenu" class="invoice-menu">
            <button *ngIf="!billsToPayMode && isAdmin" mat-menu-item
              matTooltip="Configure which fields are shown" [matTooltipShowDelay]="showToolTipDelay"
              (click)="openDisplaySettingsDialog()">
              <i class="fas fa-sliders-h"></i>
              <span>Display Settings</span>
            </button>
            <!-- SD-1235: Assign is hidden from the menu; the dialog and its handler stay for now. -->
            <button *ngIf="false && !billsToPayMode && !invoice?.archived && isEditable && formTypes?.length > 0 && userRole != 3"
              mat-menu-item matTooltip="Assign form to user" [matTooltipShowDelay]="showToolTipDelay"
              (click)="openAssignDialog()">
              <img src="../../../../assets/img/invoiceForm/assign.svg" alt="" width="22px">
              <span>Assign</span>
            </button>
            <button *ngIf="!billsToPayMode && !invoice?.archived && isEditable" mat-menu-item
              matTooltip="Archive this invoice" [matTooltipShowDelay]="showToolTipDelay" (click)="archiveInvoice()">
              <img src="../../../../assets/img/invoiceForm/archive.svg" alt="">
              <span>Archive</span>
            </button>
            <button *ngIf="!billsToPayMode && invoice?.archived" mat-menu-item matTooltip="Unarchive this invoice"
              [matTooltipShowDelay]="showToolTipDelay" (click)="unarchiveInvoice()">
              <img src="../../../../assets/img/invoiceForm/unarchive.svg" alt="">
              <span>Unarchive</span>
            </button>
            <button *ngIf="!billsToPayMode && isEditable && !invoice.processed && !invoice.isMatched" mat-menu-item
              matTooltip="Delete this invoice" [matTooltipShowDelay]="showToolTipDelay"
              (click)="showDeleteInvoiceConfirmation()">
              <img src="../../../../assets/img/invoiceForm/delete.svg" alt="">
              <span>Delete</span>
            </button>
            <button *ngIf="!billsToPayMode && invoice.processed && !invoice.isMatched" mat-menu-item
              matTooltip="Edit this invoice" [matTooltipShowDelay]="showToolTipDelay" (click)="editInvoice()">
              <img src="../../../../assets/img/edit_pencil_black.svg" alt="">
              <span>Edit</span>
            </button>
          </mat-menu>
        </div>
        <button type="button" class="close-icon" [class.overlay-close]="overlayMode || isInboxMobileMode"
          matTooltip="Close" [matTooltipShowDelay]="showToolTipDelay" aria-label="Close"
          (click)="closeFormOnBillsToPay()"
          *ngIf="(billsToPayMode && !returnBackToText) || (overlayMode && !isInboxMobileMode) || (isInboxMobileMode && !isPreviewVisible)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        </div>
      </section>

      <section class="tab-header">
        <div class="tab" [ngClass]="{'active': currentPannel === panels.DetailsTab}"
          (click)="tabClick(panels.DetailsTab)">
          <div class="caption">
            Details
          </div>
          <div class="underline"></div>
        </div>
        <div class="tab" [ngClass]="{'active': currentPannel === panels.ActivityTab}"
          (click)="tabClick(panels.ActivityTab)">
          <div class="caption">Activity</div>
          <div class="underline"></div>
        </div>
        <div class="tab" [ngClass]="{'active': currentPannel === panels.RelatedTab}"
          (click)="tabClick(panels.RelatedTab)">
          <div class="caption">Related</div>
          <div class="underline"></div>
        </div>
      </section>

    </div>

    <!-- Forward Invoice Card -->
    <!-- <div class="forward-invoice-card">
      <div class="cloud-icon">
        <img src="../../../../../assets/img/invoiceForm/cloud-upload.svg" alt="Upload Cloud" />
      </div>
      <div class="forward-header">Forward your invoices to</div>
      <div class="inbox-list">
        <div class="inbox-row">
          <span class="inbox-label">My Inbox</span>
          <span class="inbox-value">syncedstaging+test@testexpenses.syncedhq.com</span>
          <button class="copy-btn" (click)="copyToClipboard('syncedstaging+test@testexpenses.syncedhq.com')" matTooltip="Copy">Copy</button>
        </div>
        <div class="inbox-row">
          <span class="inbox-label">Company Inbox</span>
          <span class="inbox-value">syncedstaging@testexpenses.syncedhq.com</span>
          <button class="copy-btn" (click)="copyToClipboard('syncedstaging@testexpenses.syncedhq.com')" matTooltip="Copy">Copy</button>
        </div>
      </div>
      <div class="divider-or">
        <span>OR</span>
      </div>
      <div class="choose-file-block">
        <button class="choose-file-btn">Choose File</button>
        <div class="drag-drop-text">Drag & Drop your document here</div>
      </div>
    </div> -->

    <!-- Invoice Form -->
    <form id="main-form" [formGroup]="form" *ngIf="currentPannel == panels.DetailsTab" [ngStyle]="calculateDivHeight()">
      <div id="main-section">
        <!-- Invoice Fields -->
        <section class="main-section">
          <!-- Supplier -->
          <div class="form-group">
            <div class="field-label suplier-field">
              Supplier
              <span class="new" *ngIf="isNewSupplier" (click)="addNewSupplier(newSupplier)"
                [disabled]="isNewSupplierLoaded">
                <span>+New</span>
              </span>
            </div>
            <div class="inline-notice" *ngIf="isAliasWarningShown">
              <span class="inline-notice-text">Do you want to <span class="notice-action" (click)="addAlias()">add</span> this alias for {{currentSupplier.name}}?</span>
              <button type="button" class="inline-notice-close" (click)="toggleAliasWarning()"><i class="fas fa-times"></i></button>
            </div>
            <div [recordField]="'supplier'" class="field-input">
              <div class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <span class="verified" title="Matched to Xero"
                  *ngIf="!isNewSupplier && isNewSupplierLoaded">&#xf058;</span>
                <!-- Read-only, the supplier is a link to its panel; editable, the picker has one beside it. -->
                <span class="supplier-field-link" *ngIf="!isEditable && invoice.supplierName"
                      [appOpenSupplier]="currentSupplier.id || invoice.supplierId">{{ invoice.supplierName }}</span>
                <ng-select [(ngModel)]="invoice.supplierName" [items]="suppliers" formControlName="supplier"
                  [hidden]="!isEditable && invoice.supplierName"
                  [searchable]="true" [clearable]="false" bindLabel="name" (change)="onSelectSupplier($event)"
                  (keyup)="handleSupplierName($event.target.value)" [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '': 'Select Supplier'" [minlength]="isEditable ? 0 : 1"
                  class="frm-ng-select" [ngModelOptions]="{standalone: true}" (blur)="handleSupplierBlur()"
                  [closeOnSelect]="true" id="ddlsupplier">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="tax-item" [innerHTML]="item.name">
                    </div>
                  </ng-template>
                  <ng-template ng-footer-tmp
                    *ngIf="isCreateSupplierItemShown || (isNewSupplier && isCreateSupplierItemShown)">
                    <div class="create-new-supplier" (click)="createNewSupplier()">
                      <span class="spinner-wrapper" *ngIf="creatingNewSupplier" style="margin-right: 5px;">
                        <mat-spinner [diameter]="18"></mat-spinner>
                      </span>
                      <span *ngIf="!creatingNewSupplier">+ Create '{{newSupplier.name}}'</span>
                      <span *ngIf="creatingNewSupplier" style="padding-top: 2px;">Adding '{{newSupplier.name}}'</span>
                    </div>
                  </ng-template>
                </ng-select>
                <button type="button" class="supplier-field-open" *ngIf="isEditable && (currentSupplier.id || invoice.supplierId)"
                        [appOpenSupplier]="currentSupplier.id || invoice.supplierId" aria-label="Open supplier">
                  <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                    <path d="M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7 2h3v3M10 2L5.5 6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <span class="error" [ngClass]="form.controls['supplier'] ? 'error-underline' : ''"
                  *ngIf="form && form.controls['supplier'].invalid && showPublishValidation && isEditable">Please select
                  a supplier</span>
              </div>
            </div>

          </div>

          <!-- Type -->
          <div class="form-group">
            <div class="field-label">Type</div>
            <div [recordField]="'type'" class="field-input">
              <div class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [(ngModel)]="invoiceSelectedType" [items]="types" formControlName="type" [searchable]="true"
                  [clearable]="false" bindLabel="text" (change)="onSelectType($event.key)" [readonly]="!isEditable"
                  *ngIf="isEditable" [placeholder]="!isEditable ? '': 'Add Type'" [minlength]="isEditable ? 0 : 1"
                  class="frm-ng-select" [ngModelOptions]="{standalone: true}" [closeOnSelect]="true" id="ddltype">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="tax-item">
                      {{item.text}}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <input [(ngModel)]="invoiceSelectedType" class="frm-input" [ngModelOptions]="{standalone: true}"
                [placeholder]="!isEditable ? '': 'Add Details (Optional)'" type="text" [readonly]="!isEditable"
                *ngIf="!isEditable">
              <span class="error" [ngClass]="form.controls['account'] ? 'error-underline' : ''"
                *ngIf="form.controls['type'].invalid && showPublishValidation && isEditable">Please select a type</span>
            </div>
          </div>
          <!-- Ref -->
          <div class="form-group">
            <div class="field-label">
              Ref <i class="fas fa-exclamation-triangle show-warning-icon" *ngIf="isDuplicateWarningShown"
                (mouseenter)="showRefTooltip = true"></i>
            </div>
            <div class="inline-warning-row" *ngIf="showRefTooltip">
              <div class="warning account-warning">
                <div class="warning-text">
                  A document with this reference already exists. Do you want to
                  <span class="link" (click)="showDeleteInvoiceConfirmation()"
                    matTooltip="Click to delete this invoice">delete</span>
                  this duplicate?
                </div>
                <span class="close" (click)="toggleDuplicateWarning()"><i class="fas fa-times"
                    matTooltip="Close"></i></span>
              </div>
            </div>
            <div [recordField]="'invoiceNumber'" class="field-input">
              <input formControlName="invoiceNumber" id="refField" [(ngModel)]="invoice.invoiceNumber" class="frm-input"
                [maxlength]="IsQuickBook ? 21 : 250" type="text" [placeholder]="!isEditable ? '': 'No Ref'"
                [readonly]="!isEditable" [ngClass]="isEditable ? 'frm-input-active' : ''"
                (focusout)="saveOnLostFocus('Ref')" (change)="fieldWasChanged=true">
              <span class="error" [ngClass]="form.controls['invoiceNumber'] ? 'error-underline' : ''"
                *ngIf="form.controls['invoiceNumber'].invalid && showPublishValidation && isEditable">Please enter
                reference</span>
            </div>

          </div>
          <!-- Date -->
          <div class="form-group">
            <div class="field-label">Date</div>
            <div [recordField]="'date'" class="field-input">
              <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                <input type="text" matInput [matDatepicker]="datepicker" [readonly]="!isEditable"
                  [(ngModel)]="invoice.date" formControlName="date" [ngClass]="isEditable ? 'frm-input-active ' : ''"
                  [placeholder]="!isEditable ? '': dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'"
                  (click)="datepicker.open();dateChanged=true" (change)="dateChanged=true" (blur)="onDateChange()">
                <button class="cal-clear-btn" mat-button *ngIf="invoice.date" matSuffix mat-icon-button
                  aria-label="Clear" (click)="invoice.date=''">
                  <mat-icon>x</mat-icon>
                </button>
                <mat-datepicker #datepicker></mat-datepicker>
              </mat-form-field>
              <input type="text" formControlName="date" [ngModel]="invoice.date | formatedDate: '' : 'yyyy'"
                [readonly]="!isEditable" *ngIf="!isEditable" class="frm-input" name="date"
                [ngClass]="isEditable ? 'frm-input-active' : ''">
              <span class="error" [ngClass]="form.controls['account'] ? 'error-underline' : ''"
                *ngIf="form.controls['date'].invalid && showPublishValidation">Please select a date</span>
              <div class="inline-notice" *ngIf="isEditable && isInvoiceDateOld && !oldDateNoticeDismissed">
                <span class="inline-notice-text">This date is more than 12 months ago. Please confirm it's correct or update it.</span>
                <button type="button" class="inline-notice-close" (click)="oldDateNoticeDismissed = true"><i class="fas fa-times"></i></button>
              </div>
            </div>
          </div>

          <!-- Due Date -->
          <div class="form-group"
            [hidden]="(isReceipt || isExpClaim || (invoice.type == 'Credit Note' || invoice.type == 'ACCPAYCREDIT'||invoice.type == 'EXP'||invoice.type == 'Receipt'))">
            <div class="field-label">Due Date </div>
            <div [recordField]="'dueDate'" class="field-input">
              <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                <input matInput [matDatepicker]="duedatepicker" [readonly]="!isEditable" [(ngModel)]="invoice.dueDate"
                  formControlName="dueDate" (click)="duedatepicker.open();dueDateChanged=true"
                  [ngClass]="isEditable ? 'frm-input-active' : ''" (change)="dueDateChanged=true"
                  [placeholder]="!isEditable ? '': dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'"
                  (blur)="onDueDateChange()">
                <button class="cal-clear-btn" mat-button *ngIf="invoice.dueDate" matSuffix mat-icon-button
                  aria-label="Clear" (click)="invoice.dueDate=''">
                  <mat-icon>x</mat-icon>
                </button>
                <mat-datepicker #duedatepicker></mat-datepicker>
              </mat-form-field>
              <input type="text" [ngModel]="invoice.dueDate | formatedDate: '' : 'yyyy'" formControlName="dueDate"
                [readonly]="!isEditable" *ngIf="!isEditable" class="frm-input" [ngModelOptions]="{standalone: true}"
                [ngClass]="isEditable ? 'frm-input-active' : ''">
              <span class="error" [ngClass]="form.controls['dueDate'] ? 'error-underline' : ''"
                *ngIf="form.controls['dueDate'].invalid && showPublishValidation">Please select a due date</span>
            </div>
          </div>

          <!-- Planned Date (Xero planned payment date) — only valid on bills (ACCPAY),
               so hidden for Customer Invoices (ACCREC), Credit Notes, Receipts and Expense
               claims, like Due Date. Editable while drafting; read-only (with placeholder)
               once published (SD-1177). -->
          <div class="form-group"
            *ngIf="displaySettings.fields.plannedDate && IsXero && !(isReceipt || isExpClaim || invoice.type == 'Credit Note' || invoice.type == 'ACCPAYCREDIT' || invoice.type == 'EXP' || invoice.type == 'Receipt' || type == 'ACCREC' || invoice.type == 'ACCREC' || invoice.type == 'Customer Invoice')">
            <div class="field-label">Planned Date</div>
            <div class="field-input">
              <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                <input matInput [matDatepicker]="plannedDatePicker" [(ngModel)]="invoice.plannedDate"
                  [ngModelOptions]="{standalone: true}" (click)="plannedDatePicker.open();plannedDateChanged=true"
                  (change)="plannedDateChanged=true" (blur)="onPlannedDateChange()"
                  [placeholder]="dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'"
                  class="frm-input-active">
                <button class="cal-clear-btn" mat-button *ngIf="invoice.plannedDate" matSuffix mat-icon-button
                  aria-label="Clear" (click)="invoice.plannedDate=null;plannedDateChanged=true;onPlannedDateChange()">
                  <mat-icon>x</mat-icon>
                </button>
                <mat-datepicker #plannedDatePicker></mat-datepicker>
              </mat-form-field>
              <div *ngIf="!isEditable" class="frm-input" style="padding:8px 0;">
                <span *ngIf="invoice.plannedDate">{{ invoice.plannedDate | formatedDate: '' : 'yyyy' }}</span>
                <span *ngIf="!invoice.plannedDate" class="empty-field-placeholder">No Planned Date</span>
              </div>
            </div>
          </div>

          <!-- Currency -->
          <div class="form-group row field currency">
            <div class="field-label">Currency</div>
            <div [recordField]="'currency'" class="field-input custome_group_wrapper">
              <ng-select [(ngModel)]="invoice.currency" [items]="currencies" formControlName="currency"
                [searchable]="true" [clearable]="false" (change)="onCurrencyChange($event)" [readonly]="!isEditable"
                [placeholder]="!isEditable ? '': 'Select Payment Currency'" [minlength]="isEditable ? 0 : 1"
                class="frm-ng-select" [ngModelOptions]="{standalone: true}"
                [ngClass]="isEditable ? 'frm-select-active' : ''" [closeOnSelect]="true" id="currency"
                (change)="currencyChanged=true">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="tax-item">
                    {{item}}
                  </div>
                </ng-template>
              </ng-select>
              <span class="error" [ngClass]="form.controls['account'] ? 'error-underline' : ''"
                *ngIf="form.controls['currency'].invalid && showPublishValidation">Please select a currency</span>
            </div>
          </div>

          <!-- Account -->
          <div class="form-group" *ngIf="invoice.invoiceLines?.length < 2 && !billsToPayMode">
            <div class="field-label field-label-with-action">
              <div class="account-label-text">
                Account
                <i class="fas fa-exclamation-triangle show-warning-icon" *ngIf="isAccountWarningShown && account.name"
                  (mouseenter)="showAccountTooltip = true"></i>
              </div>
              <ng-container *ngIf="!billsToPayMode && (currentUser?.aiUser || currentUser?.role === 1)">
                <app-coding-suggestions [invoice]="invoice" [accounts]="accounts" [disabled]="!isEditable"
                  [label]="'Suggestions'" (suggestionApplied)="onCodingSuggestionApplied($event)"
                  (codingCopied)="onCodingSuggestionCopied($event)"></app-coding-suggestions>
              </ng-container>
            </div>
            <div class="inline-warning-row" *ngIf="showAccountTooltip">
              <div class="warning account-warning">
                <span class="spinner-wrapper" *ngIf="addDefaultAccountLoading"><mat-spinner
                    [diameter]="18"></mat-spinner></span>
                <div class="warning-text">
                  Do you want to <span class="link" (click)="addDefaultAccount(false)">add</span>
                  this as the default account for {{invoice.supplierName}}?
                </div>
                <span class="close" (click)="toggleAccountWarning()"><i class="fas fa-times"></i></span>
              </div>
            </div>

            <div [recordField]="'lines.accountId'" class="field-input">
              <div class="field-input custome_group_wrapper" *ngIf="accounts"
                [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [ngModel]="account?.name ? accountLabel(account) : null" [items]="accounts" bindLabel="name" [searchable]="true"
                           [searchFn]="accountSearchFn"
                           [clearable]="true" (change)="onSelectAccount($event)" [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '' : 'Select Account'" [minlength]="isEditable ? 0 : 1"
                  class="frm-ng-select" [ngModelOptions]="{standalone: true}"
                  [ngClass]="isEditable ? 'frm-select-active' : ''" style="padding-bottom: 0px;"
                  formControlName="account">
                  <ng-template ng-option-tmp let-item="item">
                    <div *ngIf="item.isActive === true">
                      {{ accountLabel(item) }}
                    </div>
                  </ng-template>
                </ng-select>
                <span class="error" [ngClass]="form.controls['account'] ? 'error-underline' : ''"
                  *ngIf="form.controls['account'].invalid && showPublishValidation">Please select an account</span>
              </div>
            </div>
          </div>

          <!-- Details -->
          <div class="form-group"
            *ngIf="(isEditable && !billsToPayMode && invoice.invoiceLines?.length < 2) || (!isEditable && !billsToPayMode && invoice.invoiceLines?.length < 2 && invoice.description)">
            <div class="field-label">Details</div>
            <div [recordField]="'lines.description'" class="field-input">
              <textarea matInput [(ngModel)]="invoice.description" class="frm-input"
                [ngModelOptions]="{standalone: true}" [placeholder]="!isEditable ? '': 'Add Details (Optional)'"
                type="text" [readonly]="!isEditable" [cdkTextareaAutosize]="true" [cdkAutosizeMinRows]="1"
                [cdkAutosizeMaxRows]="isEditable ? 10 : null" #autosize="cdkTextareaAutosize"
                [ngClass]="isEditable ? 'frm-input-active' : ''" (focusout)="saveOnLostFocus('Details')"
                [ngStyle]="{'resize': 'none', 'overflow': 'auto'}" (change)="fieldWasChanged=true"></textarea>
            </div>
          </div>

          <!-- Tracking category -->
          <div class="form-group" *ngIf="displaySettings.fields.xeroTrackingCategories && ((isEditable && !billsToPayMode && trackingCategories.length >
            0 && invoice.invoiceLines?.length <= 1)
            || (!isEditable && !billsToPayMode && trackingCategories.length >
            0 && (invoice.invoiceLines?.length <= 1 || invoice.invoiceLines[0]?.trackingOptions?.length > 0)))">
            <div class="field-label">{{trackingCategories[0].name}}</div>
            <div [recordField]="'lines.tracking'" class="field-input">
              <div *ngIf="!isEditable" class="frm-input" style="padding:8px 0;">
                <span *ngIf="selectedTrackingCategories[0]">{{ selectedTrackingCategories[0] }}</span>
                <span *ngIf="!selectedTrackingCategories[0]" class="empty-field-placeholder">No {{trackingCategories[0].name}}</span>
              </div>
              <div *ngIf="isEditable" class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [(ngModel)]="selectedTrackingCategories[0]" [items]="trackingCategories[0]?.options"
                  [searchable]="true" [clearable]="false" bindLabel="name" (change)="onSelectCategory($event)"
                  [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '': 'Select '+ trackingCategories[0].name + ' (Optional)'"
                  [minlength]="isEditable ? 0 : 1" class="frm-ng-select" [ngModelOptions]="{standalone: true}"
                  [ngClass]="isEditable ? 'frm-select-active' : ''" [closeOnSelect]="true" id="ddlTrackingCat1">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="tax-item">
                      {{item.name}}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="displaySettings.fields.xeroTrackingCategories && ((isEditable && trackingCategories.length >
            1 && invoice.invoiceLines?.length <= 1)
            || (!isEditable && trackingCategories.length >
            1  && (invoice.invoiceLines?.length <= 1 || invoice.invoiceLines[0]?.trackingOptions?.length > 1)))">
            <div class="field-label">{{trackingCategories[1].name}}</div>
            <div [recordField]="'lines.tracking'" class="field-input">
              <div *ngIf="!isEditable" class="frm-input" style="padding:8px 0;">
                <span *ngIf="selectedTrackingCategories[1]">{{ selectedTrackingCategories[1] }}</span>
                <span *ngIf="!selectedTrackingCategories[1]" class="empty-field-placeholder">No {{trackingCategories[1].name}}</span>
              </div>
              <div *ngIf="isEditable" class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [(ngModel)]="selectedTrackingCategories[1]" [items]="trackingCategories[1]?.options"
                  [searchable]="true" [clearable]="false" bindLabel="name" (change)="onSelectCategory($event)"
                  [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '': 'Select '+ trackingCategories[1].name + ' (Optional)'"
                  [minlength]="isEditable ? 0 : 1" class="frm-ng-select" [ngModelOptions]="{standalone: true}"
                  [ngClass]="isEditable ? 'frm-select-active' : ''" [closeOnSelect]="true" id="ddlTrackingCat2">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="tax-item">
                      {{item.name}}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <!-- QBO Class -->
          <div class="form-group" *ngIf="displaySettings.fields.classes && IsQuickBook && (qboClasses.length > 0 || invoiceClassName) && (!invoice?.invoiceLines || invoice.invoiceLines.length <= 1)">
            <div class="field-label">Class</div>
            <div class="field-input">
              <div *ngIf="!isEditable" class="frm-input" style="padding:8px 0;">
                <span *ngIf="selectedClassName || invoiceClassName">{{ selectedClassName || invoiceClassName }}</span>
                <span *ngIf="!(selectedClassName || invoiceClassName)" class="empty-field-placeholder">No Class</span>
              </div>
              <div *ngIf="isEditable" class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [items]="qboClasses" [searchable]="true" [clearable]="true" bindLabel="name" bindValue="id"
                  [ngModel]="selectedQBOClassId" (change)="onSelectQBOClass($event)" [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '': 'Select Class (Optional)'" class="frm-ng-select"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-select-active' : ''"
                  [closeOnSelect]="true" id="ddlQBOClass">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="tax-item">{{item.name}}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <!-- Customer (QBO) — billable-expense customer on the bill line(s) (SD-1177).
               Opt-in field: shown whenever enabled for a QBO org (empty until customers
               are synced). Editable while drafting; read-only value once published. -->
          <div class="form-group"
            *ngIf="displaySettings.fields.customerField && IsQuickBook && (!invoice?.invoiceLines || invoice.invoiceLines.length <= 1)">
            <div class="field-label">Customer</div>
            <div class="field-input">
              <div *ngIf="!isEditable" class="frm-input" style="padding:8px 0;">
                <span *ngIf="selectedCustomerName || invoiceCustomerName">{{ selectedCustomerName || invoiceCustomerName }}</span>
                <span *ngIf="!(selectedCustomerName || invoiceCustomerName)" class="empty-field-placeholder">No Customer</span>
              </div>
              <div *ngIf="isEditable" class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''">
                <ng-select [items]="customers" [searchable]="true" [clearable]="true" bindLabel="name" bindValue="id"
                  [ngModel]="selectedCustomerId" (change)="onSelectQBOCustomer($event)" [readonly]="!isEditable"
                  [placeholder]="!isEditable ? '': 'Select Customer (Optional)'" class="frm-ng-select"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-select-active' : ''"
                  [closeOnSelect]="true" id="ddlQBOCustomer">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="tax-item">{{item.name}}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <!-- Custom Fields -->
          <div class="customFields form-group" *ngIf="displaySettings.fields.customSyncedFields && customFields.length > 0 && isEditable">
            <div class="supplier" (click)="expandCustomFields()">
              <a [routerLink]="" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded"
                title="Expand/Collapse Custom Fields"> Optional Fields
              </a>
            </div>
          </div>
          <div *ngIf="expanded && displaySettings.fields.customSyncedFields">
            <ng-container *ngFor="let field of customFields, let i = index">
              <div class="form-group"
                *ngIf="field.is_active && ((isEditable && (field.field_type != 'dropdown' || (field.field_type == 'dropdown' && field.options))) || !isEditable)">
                <div class="field-label">{{ field.field_name }}</div>
                <!-- .frm-input inside .field-input, as every other field: on the same element
                     the form's type rule (.field-input .frm-input) never matched, and the value
                     fell back to the page's larger, darker default text. -->
                <!-- No padding of its own: .frm-input's is what the inputs above sit on, so the
                     label-to-value and value-to-next-label gaps match theirs. -->
                <div *ngIf="!isEditable" class="field-input">
                  <div class="frm-input">
                    <span *ngIf="field.field_value">{{ field.field_value }}</span>
                    <span *ngIf="!field.field_value" class="empty-field-placeholder">No {{ field.field_name }}</span>
                  </div>
                </div>
                <div class="field-input" *ngIf="isEditable && field.field_type == 'text'">
                  <input id="{{'customField_' + i }}" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="field.field_value" class="frm-input" type="text"
                    [placeholder]="!isEditable ? '': 'Enter Details'" [readonly]="!isEditable"
                    [ngClass]="isEditable ? 'frm-input-active' : ''" (focusout)="saveOnLostFocus('custom-field')"
                    (change)="fieldWasChanged=true">
                </div>
                <div class="field-input" *ngIf="isEditable && field.field_type == 'date'">
                  <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                    <input matInput [matDatepicker]="picker" [readonly]="!isEditable" [(ngModel)]="field.field_value"
                      (click)="picker.open()" [ngClass]="isEditable ? 'frm-input-active' : ''"
                      [placeholder]="!isEditable ? '': 'Select Date'" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onCustomDateChange(field)">
                    <button class="cal-clear-btn" mat-button *ngIf="field.field_value" matSuffix mat-icon-button
                      aria-label="Clear" (click)="field.field_value=''">
                      <mat-icon>x</mat-icon>
                    </button>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="field-input custome_group_wrapper" *ngIf="isEditable && field.field_type == 'dropdown'">
                  <ng-select [(ngModel)]="field.field_value" [items]="field.optionsArr"
                    [placeholder]="!isEditable ? '': 'Select Value'" class="frm-ng-select"
                    [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-select-active' : ''"
                    [readonly]="!isEditable" (focusout)="saveOnLostFocus('custom-field')"
                    (change)="fieldWasChanged=true">
                  </ng-select>
                </div>
                <div class="field-input" *ngIf="isEditable && field.field_type == 'number'">
                  <input type="text" [(ngModel)]="field.field_value" class="frm-input" (keypress)="numberOnly($event)"
                    [ngModelOptions]="{standalone: true}" (focusout)="saveOnLostFocus('custom-field')"
                    (change)="fieldWasChanged=true" [placeholder]="!isEditable ? '': 'Enter Value'"
                    [ngClass]="isEditable ? 'frm-input-active' : ''" [readonly]="!isEditable" />
                </div>
              </div>
            </ng-container>
          </div>
          <!-- Totals (IF: invoice.invoiceLines.length <= 1) -->
          <div class="form-group" [ngClass]="isEditable ? 'add-lines-hover' : ''"
            *ngIf="invoice.invoiceLines?.length <= 1 || billsToPayMode">
            <div class="field-label">
              Totals
              <span class="add-lines" matTooltip="Add new tax lines" (click)="addLinesShow()"></span>
            </div>

            <div class="totals-details" [ngClass]="billsToPayMode && (invoice.amountCredited && !invoice.amountPaid || !invoice.amountCredited && invoice.amountPaid) ? 'totals-details-bills-to-pay' :
            billsToPayMode && invoice.amountCredited && invoice.amountPaid ? 'totals-details-five-rows' : ''">
              <!-- Net Amount -->
              <div class="sub-title">Net Amount</div>
              <input [ngModel]="invoice.subTotal | number: '1.0-2'" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="invoice.subTotal=converter.stringToFloat($event,'|')" class="frm-input" readonly
                [ngClass]="isEditable ? 'bg-gray' : ''">
              <div><!-- Don't delete this div --></div>

              <!-- Tax -->
              <div class="sub-title">Tax</div>
              <input [ngModel]="invoice.totalTax | number: '1.0-2'" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="invoice.totalTax=converter.stringToFloat($event,'|')" class="frm-input bottom-border"
                readonly [ngClass]="billsToPayMode ? 'show-tax' : 'hide-tax'">

              <!-- Tax Rate -->
              <div class="sub-title custome_group_wrapper tax tax-rate"
                [ngClass]="isEditable ? 'select-actions show-tax-select' : billsToPayMode ? 'hide-tax-select' : 'select-actions show-tax-select'">
                <ng-select [recordField]="'lines.taxId'"
                  [placeholder]="isEditable ? 'Select Tax Rate' : ''" [searchable]="false" [items]="taxRates"
                  [clearable]="false" [ngModel]="selectedTaxRateId" bindLabel="name" bindValue="id"
                  (ngModelChange)="updateTaxRate($event)" formControlName="selectedTaxRate"
                  (change)="saveInvoiceWithDelay('Tax Rate')" [readonly]="!isEditable" style="width: 95%;"
                  class="frm-ng-select">
                  <!-- Value Template -->
                  <ng-template ng-label-tmp let-item="item">
                    <div class="tax-item" style="padding-top:6px">
                      <span class="tax-value">{{(invoice.amountDue - (100 * invoice.amountDue) / (100 + item.rate)) |
                        number : '1.0-2'}}</span>
                      <span class="tax-name">{{item.name}}</span>
                    </div>
                  </ng-template>

                  <!-- Option Template -->
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="tax-item">
                      <span class="tax-value">{{(invoice.amountDue - (100 * invoice.amountDue) / (100 + item.rate)) |
                        number : '1.0-2'}}</span>
                      <span class="tax-name">{{item.name}}</span>
                    </div>
                  </ng-template>
                </ng-select>
                <div class="error" *ngIf="form.controls['selectedTaxRate'].invalid && showPublishValidation">
                  Please enter a Tax Rate
                </div>
              </div>

              <!-- Credits (for Bills to Pay page only) -->
              <div class="sub-title" *ngIf="billsToPayMode && invoice.amountCredited">Credits</div>
              <div class="frm-input bottom-border" *ngIf="billsToPayMode && invoice.amountCredited"
                style="width: 100%; text-align: center; display: block !important">
                ({{invoice.amountCredited | number: '1.0-2'}})
              </div>
              <div *ngIf="billsToPayMode && invoice.amountCredited"><!-- Don't delete this div --></div>

              <!-- AmountPaid (for Bills to Pay page only) -->
              <div class="sub-title" *ngIf="billsToPayMode && invoice.amountPaid">Payments</div>
              <div class="frm-input bottom-border" *ngIf="billsToPayMode && invoice.amountPaid"
                style="width: 100%; text-align: center; display: block !important">
                ({{invoice.amountPaid | number: '1.0-2'}})
              </div>
              <div *ngIf="billsToPayMode && invoice.amountPaid"><!-- Don't delete this div --></div>

              <!-- Total -->
              <div class="sub-title">Total</div>
              <!-- Modified to handle empty/null values by using a fallback to the invoice amount -->
              <input type="text" [recordField]="'amountDue'"
                [ngModel]="amountDueRawInput || (invoice.amountDue !== undefined && invoice.amountDue !== null ? (invoice.amountDue | number:'1.2-2') : '')"
                class="frm-input" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateCalculatedTotals($event)"
                [readonly]="!isEditable" formControlName="amountDue" [ngClass]="isEditable ? 'frm-input-active' : ''"
                (focusout)="saveOnLostFocus('Total Amount')" (change)="fieldWasChanged=true"
                [style.border-top]="billsToPayMode ? '1px solid #8F8F8F': 'none'"
                [style.padding-top]="billsToPayMode ? '7px': '0'">
            </div>

            <!-- Local Amount - moved outside totals-details -->
            <div class="totals-details" *ngIf="showLocalCurrency" style="margin-top: 10px;">
              <div class="sub-title">Local Amount</div>
              <input type="number" min="0" [(ngModel)]="invoice.localCurrencyAmount" class="frm-input"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalCurrency($event)"
                [readonly]="!isEditable" [ngClass]="isEditable ? 'frm-input-active' : ''"
                (focusout)="saveLocalCurrencyWhenFocusout($event)"
                (change)="fieldWasChanged=true; localCurrencyWasChanged=true" (keyup)="decimalFilter($event)">
              <div class="sub-title" style="font-weight: normal; text-align: left; padding-left: 8px;">
                {{defaultCurrency}}</div>

              <!-- Centered exchange rate display -->
              <div></div>
              <div *ngIf="exchangeRate" class="frm-input"
                style="background: transparent; border: none; text-align: center; color: #666; font-size: 12px; font-weight: normal; padding: 0;">
                <span
                  style="display: inline-block; padding: 2px 6px; background-color: #f5f5f5; border-radius: 4px; width: auto;">
                  {{defaultCurrency}}/{{invoice.currency}} {{(1/exchangeRate) | number:'1.2-2'}}
                </span>
              </div>
              <!-- Third div removed to reduce whitespace -->
            </div>

            <span class="error" *ngIf="form.controls['amountDue'].invalid && showPublishValidation">
            </span>
          </div>

          <!-- Totals (IF: invoice.invoiceLines.length > 1) -->
          <div *ngIf="invoice.invoiceLines?.length > 1 && !billsToPayMode" class="splited-totals"
            [ngClass]="isEditable ? 'add-lines-hover' : ''">
            <div class="field-label">
              Totals
              <span class="add-lines" matTooltip="Add or edit new tax lines" (click)="addLinesShow()"></span>
            </div>
            <div class="header-section">
              <div class="caption account">
                <span>Account</span>
              </div>
              <div class="caption amount">
                <span>Amount</span>
              </div>
            </div>
            <app-totals-line-new *ngFor="let line of invoice.invoiceLines; let i = index" [invoiceLine]="line"
              [taxRates]=taxRates [accounts]=accounts [trackingCategories]=trackingCategories
              [qboClasses]="qboClasses"
              [index]="i"></app-totals-line-new>
            <div class="total-summary">
              <div></div>
              <div class="caption top-padding">Tax</div>
              <div class="value top-line top-padding">{{invoice.totalTax | number : '1.2-2'}}</div>
              <div></div>
              <div class="caption">Total</div>
              <div class="value">{{invoice.amountDue | number : '1.2-2'}}</div>
            </div>
          </div>
        </section>
        <!-- Payment Fields -->
        <section class="payment">
          <div class="payment-title">Payment</div>
          <div *ngIf="isExpClaim">
            <!-- Paid By User -->
            <div class="form-group" *ngIf="isExpClaim">
              <div class="field-label">Paid By</div>
              <div class="field-input custome_group_wrapper" [ngClass]="isEditable ? 'select-actions' : ''"
                *ngIf="users">
                <ng-select [(ngModel)]="invoice.paidBy" [items]="users" bindLabel="name" bindValue="id"
                  [searchable]="true" formControlName="paidBy" [clearable]="true"
                  [readonly]="!isEditable || (isEditable && userRole == 3)" (change)="onSelectPaidBy($event)"
                  [placeholder]="!isEditable ? '': 'Select User'" [minlength]="isEditable ? 0 : 1" class="frm-ng-select"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-select-active' : ''"
                  style="padding-bottom: 0px;" name="expUser">
                </ng-select>
                <span class="error" [ngClass]="form.controls['paidBy'] ? 'error-underline' : ''"
                  *ngIf="form.controls['paidBy'].invalid && showPublishValidation">Please select Paid By</span>
              </div>
            </div>
            <div class="form-group" *ngIf="isExpClaim && invoice.paidBy!= null">
              <div class="field-label">Report Name</div>
              <div class="field-input">
                <div class="field-input custome_group_wrapper">
                  <!-- <span class="verified" title="Matched to Xero" *ngIf="!isNewSupplier && isNewSupplierLoaded">&#xf058;</span> -->
                  <ng-select [(ngModel)]="invoice.expenseReportId" [(items)]="expClaims"
                    formControlName="expenseReportId" [searchable]="true" [clearable]="true" bindLabel="reportName"
                    bindValue="id" (change)="onSelectExpenseReport($event)"
                    (keyup)="handleExpenseReport($event.target.value)" [readonly]="!isEditable"
                    [placeholder]="!isEditable ? '': 'Add Report'" [minlength]="isEditable ? 0 : 1"
                    class="frm-ng-select" [ngModelOptions]="{standalone: true}"
                    [ngClass]="isEditable ? 'frm-select-active' : ''" (blur)="handleExpenseReportBlur()">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <div class="tax-item">
                        {{item.reportName}}
                      </div>
                    </ng-template>

                    <ng-template ng-footer-tmp
                      *ngIf="isCreateExpReportItemShown || (isNewExpReport && isCreateExpReportItemShown)">
                      <div class="create-new-supplier" (click)="createNewExpReport()">
                        <span class="spinner-wrapper" *ngIf="creatingNewExpReport" style="margin-right: 5px;">
                          <mat-spinner [diameter]="18"></mat-spinner>
                        </span>
                        <span *ngIf="!creatingNewExpReport">+ Create '{{newExpReport.reportName}}'</span>
                        <span *ngIf="creatingNewExpReport" style="padding-top: 2px;">Adding
                          '{{newExpReport.reportName}}'</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <span class="error" [ngClass]="form.controls['expenseReportId'] ? 'error-underline' : ''"
                    *ngIf="form.controls['expenseReportId'].invalid && showPublishValidation">Please select
                    report</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Status -->
          <div class="form-group" *ngIf="(!billsToPayMode && !isExpClaim && type != 'EXP')">
            <div class="field-label">Status</div>
            <div class="field-input custome_group_wrapper">
              <ng-select [(ngModel)]="invoice.paymentStatus" [items]="paymentStatusItem" bindLabel="name"
                bindValue="value" formControlName="paymentStatus" [searchable]="true" [clearable]="false"
                (change)="onChangePaymentStatus()" [readonly]="!isEditable" [placeholder]="'Payment Status'"
                [disabled]="!isEditable" [minlength]="isEditable ? 0 : 1" class="frm-ng-select"
                [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-select-active' : ''"
                [closeOnSelect]="true" id="paymentStatus">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="tax-item">
                    {{item.name}}
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="form-group"
            *ngIf="(invoice.paymentStatus == 1 || (isReceipt && invoice.type == 'Receipt')) && (invoice.type !== 'EXPCLAIMS' || type !== 'EXPCLAIMS')">
            <div class="field-label">Paid From</div>
            <div class="field-input custome_group_wrapper">
              <ng-select [(ngModel)]="invoice.paymentAccountNumber" [items]="bankAccountList" [searchable]="true"
                [disabled]="!isEditable" formControlName="paymentAccountNumber" [clearable]="false" bindLabel="name"
                bindValue="accountID" [placeholder]="!isEditable ? '': 'Select Payment Account'" class="frm-ng-select"
                style="padding-bottom: 0px;" (change)="onSelectPaymentAccount($event)"
                [ngModelOptions]="{standalone: true}">
              </ng-select>
              <ng-container>
                <span class="error" [ngClass]="form.controls['paymentAccountNumber'] ? 'error-underline' : ''"
                  *ngIf="form.controls['paymentAccountNumber'].invalid &&  showPublishValidation">Please select paid
                  from</span>
              </ng-container>
            </div>
          </div>
          <div class="form-group"
            *ngIf="(!isReceipt && invoice.type !== 'Receipt') && invoice.paymentStatus == 1 && (invoice.type !== 'EXPCLAIMS' || type !== 'EXPCLAIMS')">
            <div class="field-label">Payment Date</div>
            <div class="field-input">
              <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                <input type="text" matInput [matDatepicker]="paymentDatepicker" [readonly]="!isEditable"
                  [(ngModel)]="invoice.paymentDate" formControlName="paymentDate"
                  (ngModelChange)="savePaymentDateWhenFocusout($event)"
                  [ngClass]="isEditable ? 'frm-input-active ' : ''" [placeholder]="!isEditable ? '': 'Add Date'"
                  (click)="paymentDatepicker.open()">
                <button class="cal-clear-btn" mat-button *ngIf="invoice.paymentDate" matSuffix mat-icon-button
                  aria-label="Clear" (click)="invoice.paymentDate=''">
                  <mat-icon>x</mat-icon>
                </button>
                <mat-datepicker #paymentDatepicker></mat-datepicker>
              </mat-form-field>
              <ng-container
                *ngIf="(invoice.type == 'ACCPAY' && (invoice.paymentStatus == 1 || invoice.paymentStatus == 2 )) && !isExpClaim">
                <span class="error" [ngClass]="form.controls['paymentDate'] ? 'error-underline' : ''"
                  *ngIf="form.controls['paymentDate'].invalid  && showPublishValidation">Please select payment
                  date</span>
              </ng-container>
              <input type="text" [ngModel]="invoice.paymentDate | formatedDate: '' : 'yyyy'" [readonly]="!isEditable"
                *ngIf="!isEditable" class="frm-input" [ngModelOptions]="{standalone: true}"
                [ngClass]="isEditable ? 'frm-input-active' : ''">
            </div>
          </div>
          <div *ngIf="!isExpClaim">
            <!-- Details -->
            <div *ngIf="(invoice.paymentStatus != 1 && invoice.paymentStatus != 2 )">
              <div class="form-group" style="margin-top: 15px;"
                *ngIf="!isEditable && paymentViewStateValue == paymentViewStateValues.AddPaymentAccount">
                <div class="field-label">Details</div>
                <div class="field-label" style="color: #8F8F8F">No bank details on file</div>
              </div>
              <div class="form-group" style="margin-top: 15px;"
                *ngIf="countryCode == 'AU' && isEditable && paymentViewStateValue == paymentViewStateValues.AddPaymentAccount && !showPaymentAccountFields">
                <div class="field-label">Details</div>
                <div class="field-label add-bank-account" matTooltip="Add supplier's BSB and Account Number"
                  [matTooltipShowDelay]="showToolTipDelay" (click)="addPaymentAccount()">Add Payment Account</div>
              </div>
            </div>
            <div class="form-group"
              *ngIf="countryCode == 'AU' && (invoice.paymentStatus != 1 && invoice.paymentStatus != 2 ) && (paymentViewStateValue != paymentViewStateValues.AddPaymentAccount || showPaymentAccountFields)">
              <div class="field-label">Details</div>
              <div class="details-row field-input">
                <div class="subtitle">BSB:</div>
                <input type="text" class="data" mask="000-000" [(ngModel)]="bankAccount.BSBNumber" maxlength="7"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-input-active' : ''"
                  style="width: 71%;" (change)="bankAccountChanged($event.target.value,countryCode)"
                  (ngModelChange)="updateBSB($event)" name="BSB" #BSB="ngModel" pattern="\d{3}-\d{3}"
                  [readonly]="!isEditable" [dropSpecialCharacters]="false" (paste)="onPasteFix($event)">
              </div>
              <div *ngIf="BSB.invalid && (BSB.dirty || BSB.touched)" class="error font-12px">
                <div *ngIf="BSB.errors?.pattern">
                  BSB must be 6 digits long and have the format: XXX-XXX
                </div>
              </div>
              <div class="details-row field-input">
                <div class="subtitle">Account No:</div>
                <input type="text" class="data" [(ngModel)]="bankAccount.accountNumber"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-input-active' : ''"
                  style="width: 60%;" (change)="bankAccountChanged($event.target.value)" name="accountNo"
                  #accountNo="ngModel" pattern="^[0-9]*$" [readonly]="!isEditable">
              </div>
              <div *ngIf="accountNo.invalid && (accountNo.dirty || accountNo.touched)" class="error font-12px">
                <div *ngIf="accountNo.errors?.pattern">
                  Account Number must have only digits
                </div>
              </div>
            </div>
            <div class="form-group" style="margin-top: 15px;"
              *ngIf="countryCode == 'US' && isEditable && paymentViewStateValue == paymentViewStateValues.AddPaymentAccount && !showUSPaymentAccountFields && (invoice.paymentStatus != 1 && invoice.paymentStatus != 2 )">
              <div class="field-label">Details</div>
              <div class="field-label add-bank-account" matTooltip="Add supplier's Routing and Account Number"
                [matTooltipShowDelay]="showToolTipDelay" (click)="addUSPaymentAccount()">
                Add Payment Account
              </div>
            </div>
            <div class="form-group"
              *ngIf="countryCode == 'US' && (invoice.paymentStatus != 1 && invoice.paymentStatus != 2 ) && (paymentViewStateValue != paymentViewStateValues.AddPaymentAccount || showUSPaymentAccountFields)">
              <div class="field-label">Details</div>
              <div class="details-row field-input">
                <div class="subtitle">Routing No.:</div>
                <input type="text" class="data" [(ngModel)]="bankAccount.routingNumber"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-input-active' : ''"
                  style="width: 71%;" (change)="bankAccountUSChanged($event.target.value)"
                  (ngModelChange)="updateRouting($event)" (keypress)="numberOnly($event)" name="Routing"
                  #Routing="ngModel" pattern="\d{9}" maxLength="9" [readonly]="!isEditable" mask="000000000"
                  [dropSpecialCharacters]="true" [validation]="true" inputmode="numeric">
              </div>
              <div *ngIf="Routing.invalid && (Routing.dirty || Routing.touched)" class="error font-12px">
                <div *ngIf="Routing.errors?.pattern">
                  Routing Number must be 9 digits long and have the format: XXXXXXXXX
                </div>
              </div>
              <div class="details-row field-input">
                <div class="subtitle">Account No:</div>
                <input type="text" class="data" [(ngModel)]="bankAccount.accountNumberUS"
                  [ngModelOptions]="{standalone: true}" [ngClass]="isEditable ? 'frm-input-active' : ''"
                  style="width: 60%;" (change)="bankAccountUSChanged($event.target.value)" name="accountNoUS"
                  #accountNoUS="ngModel" pattern="^[0-9]*$" [readonly]="!isEditable">
              </div>
              <div *ngIf="accountNoUS.invalid && (accountNoUS.dirty || accountNoUS.touched)" class="error font-12px">
                <div *ngIf="accountNoUS.errors?.pattern">
                  Account Number must have only digits
                </div>
              </div>
            </div>
          </div>
        </section>
        <carousel itemsPerSlide="1" [interval]="false">
          <slide style="height: 70px;" *ngIf="countryCode == 'US' && isEditable && paymentViewStateValue != paymentViewStateValues.HideWarning &&
              paymentViewStateValue != paymentViewStateValues.AddPaymentAccount && warningIsReadyToBeShown">
            <div class="slide">
              <div class="content">
                <div class="bsb-logic">
                  <div class="prompt">
                    <div class="icon">
                      <img src="../../../../assets/img/invoiceForm/warning.svg" alt=""
                        *ngIf="paymentViewStateValue != paymentViewStateValues.SameValues">
                      <img src="../../../../assets/img/invoiceForm/check.svg" alt=""
                        *ngIf="paymentViewStateValue == paymentViewStateValues.SameValues">
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.SameValues">
                      <span>Bank account details on the invoice have been checked and are the same as what is on
                        file</span>
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.DifferentValues">
                      <div class="text">The bank account details on the invoice are different to what is on file</div>
                      <div class="text">
                        Routing No: {{
                        invoice.routingNumber
                        }}
                      </div>
                      <div class="text">Account No: {{invoice.accountNumberUS}}</div>
                      <div class="control-link" (click)="updateBankDetails(countryCode)"
                        matTooltip="Accept recognized Routing No and Account Number from the invoice"
                        [matTooltipShowDelay]="showToolTipDelay">Update Bank Details</div>
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.SaveNewValues">
                      <div class="text">Bank account details have been extracted on the invoice. Do you want to save
                        them for {{currentSupplier?.name ? currentSupplier.name : invoice?.supplierName}}?</div>
                      <div class="control-link" (click)="saveBankDetails(countryCode)"
                        matTooltip="Save recognized Routing No and Account Number for the current Supplier"
                        [matTooltipShowDelay]="showToolTipDelay">Save Bank Details</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
          <slide *ngIf="countryCode == 'AU' && isEditable && paymentViewStateValue != paymentViewStateValues.HideWarning &&
              paymentViewStateValue != paymentViewStateValues.AddPaymentAccount && warningIsReadyToBeShown">
            <div class="slide">
              <div class="content">
                <div class="bsb-logic">
                  <div class="prompt">
                    <div class="icon">
                      <img src="../../../../assets/img/invoiceForm/warning.svg" alt=""
                        *ngIf="paymentViewStateValue != paymentViewStateValues.SameValues">
                      <img src="../../../../assets/img/invoiceForm/check.svg" alt=""
                        *ngIf="paymentViewStateValue == paymentViewStateValues.SameValues">
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.SameValues">
                      <span>Bank account details on the invoice have been checked and are the same as what is on
                        file</span>
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.DifferentValues">
                      <div class="text">The bank account details on the invoice are different to what is on file</div>
                      <div class="text">BSB: {{invoice.bsbNumber}}</div>
                      <div class="text">Account No: {{invoice.accountNumber}}</div>
                      <div class="control-link" (click)="updateBankDetails(countryCode)"
                        matTooltip="Accept recognized BSB and Account Number from the invoice"
                        [matTooltipShowDelay]="showToolTipDelay">Update Bank Details</div>
                    </div>
                    <div class="content" *ngIf="paymentViewStateValue == paymentViewStateValues.SaveNewValues">
                      <div class="text">Bank account details have been extracted on the invoice. Do you want to save
                        them for {{currentSupplier?.name ? currentSupplier.name : invoice?.supplierName}}?</div>
                      <div class="control-link" (click)="saveBankDetails(countryCode)"
                        matTooltip="Save recognized BSB and Account Number for the current Supplier"
                        [matTooltipShowDelay]="showToolTipDelay">Save Bank Details</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </form>

    <!-- Split Lines Functionality -->
    <app-add-lines *ngIf="currentPannel == panels.SplitLinesPanel" (moveBack)="addLinesShow()" [accounts]="accounts"
      [invoiceLines]="invoice.invoiceLines" [taxRates]="taxRates" [selectedTaxRateId]="organizationTaxRateId"
      [trackingCategories]="trackingCategories"
      [qboClasses]="qboClasses"
      [qboCustomers]="customers"
      [isQuickBook]="IsQuickBook"
      [accountDisplay]="displaySettings.accountDisplay"
      [displayFields]="displaySettings.fields"
      [supplierName]="currentSupplier.name ? currentSupplier.name : invoice.supplierName"
      [invoiceAmountDue]="invoice.amountDue" (updateLines)="updateInvoiceLines($event)">
    </app-add-lines>

    <!-- Activity Panel -->
    <app-activity *ngIf="currentPannel == panels.ActivityTab" (moveBack)="showActivityPanel()"
      [invoiceColorNumber]="invoiceColorNumber" [invoiceMode]="true" [billsToPayMode]="billsToPayMode"
      [openNotesFirst]="openNotesFirst"
      [invoiceId]="invoice.id == '00000000-0000-0000-0000-000000000000' ? invoice.referenceId : invoice.id"
      [supplierName]="currentSupplier.name ? currentSupplier.name : invoice.supplierName">
    </app-activity>

    <!-- Related -->
    <app-related *ngIf="currentPannel == panels.RelatedTab" [invoice]="invoice" [supplierId]="invoice?.supplierId"
      (showContactForm)="toggleCreateSupplierForm($event)" (clickInvoiceEvent)="closeContactForm($event)"
      (clickInvoiceFormEvent)="openCompletedTaskForm($event)" [invoiceColorNumber]="invoiceColorNumber"
      [hexColorClass]="hexColorClass" [billsToPayMode]="billsToPayMode" [completedTasks]="completedTasks">
    </app-related>

    <!-- Contact From -->
    <app-supplier-contancts *ngIf="currentPannel == panels.ContactForm" [supplier]="newSupplier" [account]="bankAccount"
      [accounts]="accounts" [billsToPayMode]="billsToPayMode" [isEditable]="true"
      [invoiceColorNumber]="invoiceColorNumber" (newSupplier)="addNewSupplier($event)"
      (isClosed)="toggleCreateSupplierForm($event)" (closeFormEvent)="closeContactForm($event)">
    </app-supplier-contancts>

    <!-- Invoice Document Preview. The wrappers exist only while their preview does:
         .preview-invoice-web is a fixed, full-height box at z-index 99999, and left empty
         it lay invisibly over whatever was beside the form (the Inbox's own document
         viewer, a table) and swallowed every click, drag and wheel aimed at it. -->
    <!-- Mobile and the extensions: the same viewer as the desktop one, over the whole screen.
         The old mobile viewer sized its page to the window (45vw/85vw by 100vh) under a 75px
         bar, so in a narrow panel the page ran off both sides. -->
    <div class="preview-invoice" *ngIf="isPreviewVisible">
      <app-invoice-preivew-web [isHorizontalDirection]=isHorizontalDirection [invoice]="invoice"
        (isClosed)="toggleCreateSupplierForm($event)" (closeFormEvent)="closeInvoicePreviewForm($event)">
      </app-invoice-preivew-web>
    </div>
    <div class="preview-invoice-web" *ngIf="isPreviewVisibleWeb">
      <app-invoice-preivew-web [isHorizontalDirection]=isHorizontalDirection
        [invoice]="invoice" (isClosed)="toggleCreateSupplierForm($event)"
        (closeFormEvent)="closeInvoicePreviewWebForm($event)">
      </app-invoice-preivew-web>
    </div>
  </div>
</div>
<ng-container *ngIf="isPageLoaded">
  <div id="floating-div" class="floating-button-div"
    *ngIf="(!billsToPayMode || approvalMode) && (currentPannel == panels.DetailsTab) ">
    <div class="match-mobile-view" *ngIf="showMatchDialog">
      <ng-container *ngIf="invoice?.unreconciledData?.length >0">
        <div class="close-icon match-close" matTooltip="Close Match" [matTooltipShowDelay]="showToolTipDelay"
          (click)="closeReportMatch()">
          <img src="../../../../../assets/img/close-icon.svg" alt="">
        </div>
        <button type="button" class="match-header"
          [class.match-header--collapsed]="!isMatchPanelExpanded"
          [attr.aria-expanded]="isMatchPanelExpanded"
          aria-controls="match-list"
          (click)="toggleMatchPanel()">
          <svg class="match-header__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
          <span class="match-header__title">
            <ng-container *ngIf="!selectedMatch">
              {{ invoice.unreconciledData.length }}
              possible match{{ invoice.unreconciledData.length === 1 ? '' : 'es' }}
            </ng-container>
            <ng-container *ngIf="selectedMatch">
              <span class="match-header__selected-prefix">Match:</span>
              <span class="match-header__selected-desc" [title]="selectedMatch.description">
                {{ selectedMatch.description }}
              </span>
              <span class="match-header__selected-meta" *ngIf="selectedMatch.reportName">
                · {{ selectedMatch.reportName }}
              </span>
            </ng-container>
          </span>
        </button>
        <div class="match-list" id="match-list" *ngIf="isMatchPanelExpanded">
          <ng-container *ngFor="let item of invoice.unreconciledData; let i = index">
            <div class="bg-grey match-card"
              *ngIf="showAllMatches || i === 0"
              [class.match-card--selected]="item.selected"
              role="button"
              tabindex="0"
              [attr.aria-pressed]="item.selected"
              [attr.aria-label]="(item.selected ? 'Selected match: ' : 'Select match: ') + item.description"
              (click)="changeSelectedMatch(item.selected, item.unreconciledReportId)"
              (keydown.enter)="changeSelectedMatch(item.selected, item.unreconciledReportId); $event.preventDefault()"
              (keydown.space)="changeSelectedMatch(item.selected, item.unreconciledReportId); $event.preventDefault()">
              <div class="match-card__check" aria-hidden="true">
                <svg *ngIf="item.selected" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="match-card__body">
                <div class="match-card__row match-card__row--top">
                  <div class="match-card__desc" [title]="item.description">
                    {{ item.description }}
                    <img class="match-card__reason-icon"
                      src="../../../../../assets/img/round-information-outline-black-icon.svg"
                      *ngIf="item.matchReason" width="14" height="14" title={{item.matchReason}} alt="" />
                  </div>
                  <div class="match-card__amount"
                    [class.match-card__amount--positive]="item.amount > 0"
                    [class.match-card__amount--negative]="item.amount < 0">
                    <ng-container *ngIf="item.amount > 0">+{{ item.amount | number : '1.2-2' }}</ng-container>
                    <ng-container *ngIf="item.amount < 0">({{ item.amount * -1 | number : '1.2-2' }})</ng-container>
                    <ng-container *ngIf="!item.amount">-</ng-container>
                  </div>
                </div>
                <div class="match-card__row match-card__row--meta">
                  <div class="match-card__date">{{ item.transactionDate | formatedDate }}</div>
                  <div class="match-card__report" *ngIf="item.reportName" [title]="item.reportName">
                    {{ item.reportName }}
                  </div>
                </div>
                <div class="suggest-card__submitter" *ngIf="item.assignedTo" [title]="item.assignedTo">
                    <i class="far fa-user suggest-card__submitter-icon" aria-hidden="true"></i>
                    {{ item.assignedTo }}
                  </div>
              </div>
            </div>
          </ng-container>
          <button type="button"
            class="match-show-more"
            *ngIf="invoice.unreconciledData.length > 1"
            (click)="toggleShowAllMatches()">
            {{ showAllMatches ? 'Show less' : 'Show ' + (invoice.unreconciledData.length - 1) + ' more' }}
          </button>
        </div>
      </ng-container>
    </div>
    <!-- An approval asked of (or by) the viewer on this bill: where Publish sits, and in its place. -->
    <app-approval-block class="approval-footer" recordType="invoice" [recordIds]="reviewRecordIds"
      (activeChange)="approvalActive = $event">
    </app-approval-block>
    <!-- Buttons -->
    <div class="buttons">
      <button id="saveButton" type="button" class="btn-save" style="position:relative" (click)="save(fieldName)"
        *ngIf="isEditable"></button>
      <app-common-button [buttonText]="'Update'" (buttonEvent)="saveAfterPublish(fieldName)"
        [disabled]="isSaveLoader || form.invalid" [loading]="loading" [matTooltipShowDelay]="showToolTipDelay"
        *ngIf="isEditable && invoice.processed && !invoice.isMatched" style="width: 100%;">
      </app-common-button>
      <app-common-button [buttonText]="'Save'" (buttonEvent)="reroutAfterPublishing()"
        [disabled]="loading || (!invoice.required_Fields)" [loading]="loading" [matTooltipShowDelay]="showToolTipDelay"
        style="width: 100%;" *ngIf="!canPublish">
      </app-common-button>
      <div *ngIf="canPublish && !invoice.processed && !approvalActive"
        [matTooltip]="!invoice.required_Fields ? 'Complete all required fields above' : ''" style="width: 100%;">
        <app-common-button [buttonText]="publishButtonText" (buttonEvent)="submit()"
          [disabled]="loading || (!invoice.required_Fields)" [loading]="loading"
          [matTooltipShowDelay]="showToolTipDelay" [tooltip]="IsQuickBook ? 'Publish to QuickBooks' : 'Publish to Xero'"
          *ngIf="((isEditable || isMatchPublish) && !invoice.processed  && canPublish) || (invoice.processed && isMatchPublish  && canPublish)"
          style="width: 100%;display: inline-block; height: 40px;">
        </app-common-button>
        <!-- 
        <button type="button" class="btn-publish" style="position:relative" (click)="submit()"
          [matTooltipShowDelay]="showToolTipDelay" [disabled]="loading || (!invoice.required_Fields)"
          [matTooltip]="IsQuickBook ? 'Publish to QuickBooks' : 'Publish to Xero'"
          *ngIf="((isEditable || isMatchPublish) && !invoice.processed  && canPublish) || (invoice.processed && isMatchPublish  && canPublish)"
          [ngClass]="loading || (!invoice.required_Fields || !canPublish) ? 'disabled' : ''">
          <span class="btn-text" *ngIf="!loading && !isMatchPublish && isEditable">Publish</span>
          <span class="btn-text" *ngIf="!loading && isMatchPublish && isEditable && !invoice.processed">Match &
            Publish</span>
          <span class="btn-text" *ngIf="!loading && isMatchPublish && !isEditable">Match</span>
          <span class="btn-text" *ngIf="loading && !isMatchPublish && isEditable">Publishing...</span>
          <span class="btn-text" *ngIf="loading && isMatchPublish">Matching...</span>
          <span class="spinner-wrapper" *ngIf="loading"><mat-spinner [diameter]="18"></mat-spinner></span>
        </button> -->
      </div>
      <app-common-button [buttonText]="isApproving ? 'Approving' : 'Approve'" (buttonEvent)="approveCurrentInvoice()"
        [disabled]="isApproving" [loading]="isApproving" [matTooltipShowDelay]="showToolTipDelay"
        *ngIf="approvalMode && isApproveButtonShown && !approvalActive" style="width: 100%;">
      </app-common-button>
    </div>
  </div>
</ng-container>
<app-entertainment-details [(visible)]="showEntertainmentForm"
  [isEditable]="(isEditable && isFormEditable) || (invoiceTaskMode)" [customFields]="customFormFields" [formId]="formId"
  [taskId]="taskId" [formName]="formName" [assignToUserName]="assignToUserName"
  (saved)="onEntertainmentDetailsSaved($event)" (close)="closeForm()">
</app-entertainment-details>

<div class="modal fade data_modal apiKey_modal" [config]="{'backdrop':'static', 'keyboard': false}" bsModal
  #DefaultTaxModel="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div>
          <div class="dm_head" style="padding: 6px;">
            <h3>Select Default Tax</h3>
            <h5 style="display: flex; justify-self: center; color: #999;margin-top: 5px;">Select a default tax rate for
              submitted expenses</h5>
          </div>
          <div class="dm_content">
            <form class="signup-form" role="form" name="loginForm">
              <div class="form-group">
                <ng-select placeholder="Select Tax Rate" class="custom height36" [items]="taxRates" [searchable]="false"
                  [clearable]="false" bindLabel="name" bindValue="id" [loading]="taxRatesLoading"
                  [(ngModel)]="selectedTaxRateId">
                </ng-select>
              </div>
            </form>
            <div class="modal_btns">
              <button class="custom_button yellow" style="cursor:pointer;" (click)="saveDefaultTax()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
